import { createElement } from "@max/max";
import { getFullScreenSize } from "../utils/layout";
import LoadingView from '@max/leez-loading-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { setRemConfig } from '@max/leez-style-util';
import { hotelTheme } from '@max/leez-theme-hotel';
import { setCustomTheme } from '@max/leez-context';
import TopView from '@max/leez-top-view';
setCustomTheme(hotelTheme);
setRemConfig({
    enabled: true
});
export function useLoading() {
    const ctx = useMonitorEngineContext();
    const { fullScreenHeight } = getFullScreenSize();
    function openLoading(content) {
        const LoadingPanel = <TopView>
      <ModalBaseContainer visible showMask={false}>
        <View style={{
                height: '184rpx',
                width: '184rpx',
                backgroundColor: 'rgba(26, 26, 26, 0.9)',
                borderRadius: '16rpx',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
          <LoadingView showIcon showContent bgColorType="dark" level="medium" theme={{
                medium: {
                    spacing: 15,
                    textType: 'body4'
                }
            }} animate content={content || '加载中'}/>
        </View>
      </ModalBaseContainer>
    </TopView>;
        ctx._topPanelAPI.setPanelHeight(fullScreenHeight);
        ctx._topPanelAPI.setContent(LoadingPanel);
        ctx._topPanelAPI.setVisible({
            visible: true
        });
    }
    function closeLoading() {
        ctx._topPanelAPI.setContent(null);
        ctx._topPanelAPI.setVisible({
            visible: false
        });
    }
    return {
        openLoading,
        closeLoading
    };
}
